<aslib-title Text="Liquidação" SubText=" " Icon="fa fas fa-tasks"></aslib-title>
<div class="fieldRow"></div>
<br>

<div class="form-row">
  <div class="col-md-4">
    <div class="form-inline">
      <label for="dataEnvioLiq">Data de envio da LIQ:</label>
      <input class="form-control ml-3 mr-2 col-md-5" name="dataEnvioLiq" (ngModelChange)="dataEnvioLiq = $event"
        type="date" [ngModel]="dataEnvioLiq">
      <button class="btn btn-primary" type="button" (click)="getArquivoLiq()"><em
          class="fa fa-caret-right"></em></button>
    </div>
  </div>

  <div class="col-md-6">
    <div class="form-inline">
      <label>Resumo da LIQ:</label>
      <select class="form-control ml-3 mr-2 col-md-6" [(ngModel)]="arquivoLiq">
        <option value="" disabled selected>Selecione...</option>
        <option *ngFor="let item of arquivosLiq" [ngValue]="item.key">{{item.value}} </option>
      </select>
      <button type="button" class="btn btn-primary"  [disabled] = "habilitarCarregar" (click)="emitterArquivoLiq(arquivoLiq)">Carregar</button>
    </div>
  </div>

    <div class="col-md-2">
    <div class="form-inline">
       <button type="button" class="btn btn-outline-primary" (click)="openModalParametros(parametros)">Exibir
        Parâmetros</button>
      <ng-template #parametros>
        <gpa-param-pagamento [modoEdicao]="false"></gpa-param-pagamento>
      </ng-template>
    </div>
  </div>
</div>

<br>
<div class="card-block" *ngIf="showTabsNavigation">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item active"><a class="nav-link active" routerLinkActive="active"
        [routerLink]="['processado_liq']"><strong>LIQs processadas</strong></a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active"
      [routerLink]="['nao_processado_liq']"><strong>LIQs não processadas</strong></a></li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade show active" role="tabpanel">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<br>



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq/liq.component.html